/**
 * jquery for all
 */

import bsCustomFileInput from 'bs-custom-file-input'

$(function () {

  bsCustomFileInput.init()

  $(".toTop").click(function(event){
    event.preventDefault(event);
    $('html, body').animate({scrollTop : 0},1200);
  });

  $('[data-toggle="tooltip"]').tooltip();

  $("#carousel").css('height', '' + Math.round($(window).height() - 20)).css('width', '' + Math.round($(window).width()));

  /* Toggle the wordz on the home page */
  const word_chng = function() {
    const words = ['Live <span>Escape Rooms</span>','<p style="font-size: 70%;">Branches in <span>Nottingham</span> and <span>Sheffield</span></p>','Use your <span>brains</span> not brawn'];
    let cnt = 0;

    setInterval(function() {
      $("#wordz").fadeOut(function(){
        cnt = (cnt + 1) % words.length;
        $(this).html(words[cnt]).fadeIn();
      });
    }, 4000);
  }

  if ($('#wordz').length) { // only do it if we have #wordz
    word_chng();
  }

  // setup the game carousel
  $('#g-carousel').carousel({
    interval: false
  });
  // handle the movie poster click
  $('.mp-carousel').click(function() {
    const slideNumber = $(this).attr('data-slide-number');
    $('#g-carousel').carousel(parseInt(slideNumber));
  });

  // Negative money values should be red
  $(".money:contains('-')").css("color", "red");
  // Negative money values should be red
  $(".money-inverse:not(:contains('-'),:contains('£0.00'),:contains('$0.00'),:contains('€0.00'))").css("color", "red");

}); // $(function () {
